import React from "react";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import { ReactSession } from "react-client-session";

const RequireAuth = ({ allowedRole }) => {
  const location = useLocation();

  const role = ReactSession.get("role");
  const username = ReactSession.get("username");

  return allowedRole.includes(role) ? (
    <Outlet />
  ) : username ? (
    <Navigate to="/unauthorized" state={{ from: location }} replace />
  ) : (
    <Navigate to="/" state={{ from: location }} replace />
  );
};

export default RequireAuth;
